export default "https://cdn-static.gokick.com/assets/d8950a20925d8040d2b2bc8b449b43040bc9b501/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";